import { createSelector } from 'reselect'
import { getExperiencesPassportCheckoutKey } from 'checkout/lib/experiencesPassport'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'

const isExperiencesPassportReady = createSelector(
  (state: App.State) => state.checkout.cart,
  (state: App.State) => state.checkout.experiencesPassportReconciliation,
  (cart, reconciliation) => {
    if (findPostPurchaseCheckout(cart.mode)) return true

    const key = getExperiencesPassportCheckoutKey(cart)
    return !key || (reconciliation?.key === key && reconciliation.status !== 'loading')
  },
)

export default isExperiencesPassportReady
